<template>
  <PersonalLayout>
    <template v-slot:header>
      <AppHeader />
    </template>
    <template v-slot:side>
      <router-link to="/personal-objects" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M20 7L12 3L4 7M20 7L12 11M20 7V17L12 21M12 11L4 7M12 11V21M4 7V17L12 21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Мои объекты') }}</span>
      </router-link>
      <router-link to="/my-fonts" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M4 7V4H20V7M9 20H15M12 4V20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Мои шрифты') }}</span>
      </router-link>
      <router-link to="/my-processings" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('ИИ обработки') }}</span>
      </router-link>
      <router-link to="/personal-subscription" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M21 4H3C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18V6C23 4.89543 22.1046 4 21 4Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M1 10H23" stroke="currentColor" stroke-width="2"/></svg>
        <span>{{ $t('Подписка') }}</span>
      </router-link>
      <div class="side-slide active">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Аккаунт') }}</span>
      </div>
      <router-link to="/personal-security" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Безопасность') }}</span>
      </router-link>
      <router-link v-if="isAmbassador" to="/partner-program" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"/><path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Партнёрская программа') }}</span>
      </router-link>
      <router-link v-if="isAdmin" to="/admin" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 15C15.866 15 19 11.866 19 8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8C5 11.866 8.13401 15 12 15Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.21 13.89L7 23L12 20L17 23L15.79 13.88" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Панель администратора') }}</span>
      </router-link>
      <div class="side-slide logout-slide" @click="handleLogout">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><polyline points="16,17 21,12 16,7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Выйти') }}</span>
      </div>
    </template>
    <template v-slot:content>
      <div class="content-block">
        <div class="profile-header">
          <div class="avatar-container">
            <img class="avatar" :src="avatarSrc" alt="avatar" />
            <div class="camera-icon-wrapper" @click="triggerAvatarUpload" v-if="!isUploading">
              <IconCamera />
            </div>
            <div class="avatar-progress-overlay" v-if="isUploading">
              <div class="progress-circle">
                <svg viewBox="0 0 36 36" class="circular-progress">
                  <path class="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                  <path class="circle-progress" :stroke-dasharray="`${uploadProgress}, 100`" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                </svg>
                <span class="progress-text">{{ uploadProgress }}%</span>
              </div>
            </div>
            <input type="file" ref="avatarInput" class="file-input" accept="image/*" @change="onAvatarChange" />
          </div>
          <div class="profile-info">
            <h1>{{ user?.name || $t('Имя не указано') }}</h1>
            <p class="registration">{{ $t('Год регистрации') }} {{ registrationYear }}</p>
          </div>
        </div>
      </div>
      <div class="spacer-10"></div>
      <div class="content-block content-block--full">
        <form action="" @submit.prevent="handleSubmit">
          <div class="content-block__row">
            <div class="content-block__column">
              <div class="detail-item">
                <AppInput v-model="tempValues.login" type="text" :label="$t('Логин')" :placeholder="$t('Введите')" />
              </div>
              <div class="detail-item">
                <AppInput v-model="tempValues.fullname" type="text" :label="$t('Имя')" :placeholder="$t('Введите')" />
              </div>
              <div class="detail-item-row">
                <div class="detail-item detail-item--half">
                  <AppInput v-model="tempValues.phone" @input="onPhoneInput" type="text" :label="$t('Телефон')" :placeholder="$t('Введите')" />
                </div>
                <div class="detail-item detail-item--half">
                  <span class="detail-title">{{ $t('Дата рождения') }}</span>
                  <VueDatePicker v-model="tempValues.birth_date" :locale="$locale.value" auto-apply placeholder="__.__.__" :format="dateFormat">
                    <template #input-icon>
                      <IconCalendar />
                    </template>
                  </VueDatePicker>
                </div>
              </div>
            </div>
            <div class="content-block__column">
              <div class="detail-item">
                <AppInput v-model="tempValues.email" type="email" :label="$t('Электронная почта')" :placeholder="$t('Введите')" />
              </div>
              <div class="detail-item">
                <span class="detail-title">{{ $t('Страна') }}</span>
                <div class="custom-select" @click="toggleCountryDropdown">
                  <div class="select-header">
                    <span class="selected-option" :class="{ placeholder: !tempValues.country }">
                      {{ tempValues.country ? $t(tempValues.country) : $t('Выберите из списка') }}
                    </span>
                    <img src="@/assets/images/content/arrow-down.svg" class="dropdown-icon" :class="{ rotated: showCountryDropdown }" />
                  </div>
                  <transition name="fade">
                    <div class="dropdown-options" v-show="showCountryDropdown">
                      <div v-for="country in countries" :key="country" class="option" @click="selectCountry(country, $event)">
                         {{ $t(country) }}
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
          <div class="content-block__action">
            <AppButton :label="$t('common.save')" type="submit" />
            <AppButton :label="$t('account.reset')" type="reset" variant="grey" @click="resetForm" />
          </div>
        </form>
      </div>
      <div class="spacer-10"></div>
      <div class="content-block content-block--full">
        <div class="language-settings">
          <div>
            <h2>{{ $t('account.languageTitle') }}</h2>
            <p>{{ $t('account.languageDescription') }}</p>
          </div>
          <label class="language-select-label">
            <span>{{ $t('account.interfaceLanguage') }}</span>
            <select v-model="selectedLanguage" class="language-select" :disabled="isLanguageSaving" @change="changeLanguage">
               <option value="ru">{{ $t('Русский') }}</option>
               <option value="en">English</option>
            </select>
          </label>
        </div>
      </div>
    </template>
  </PersonalLayout>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import PersonalLayout from '@/layout/PersonalLayout.vue';
import IconCamera from '@/components/icons/IconCamera.vue';
import IconCalendar from '@/components/icons/IconCalendar.vue';
import AppButton from '@/components/ui/AppButton.vue';
import AppInput from '@/components/ui/AppInput.vue';
import { mapGetters, mapState } from 'vuex';
import { useToast } from 'vue-toastification';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { setLocale } from '@/i18n';

export default {
  name: 'ProfilePage',
  components: {
    AppHeader,
    VueDatePicker,
    PersonalLayout,
    IconCamera,
    IconCalendar,
    AppButton,
    AppInput,
  },

  data() {
    return {
      date: new Date(),
      toast: useToast(),
      editing: {
        fullname: false,
        phone: false,
        email: false,
      },
      tempValues: {
        login: '',
        fullname: '',
        phone: '',
        email: '',
        birth_date: null,
        country: '',
      },
      avatarFile: null,
      avatarPreview: null,
      uploadProgress: 0,
      showCountryDropdown: false,
      countries: ['Россия', 'Беларусь', 'Казахстан'],
      isAmbassador: false,
      selectedLanguage: this.$locale?.value || 'ru',
      isLanguageSaving: false,
    };
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('ui', ['isUploading']),
    ...mapGetters('subscription', ['isAdmin']),

    registrationYear() {
      if (this.user?.created_at) {
        return new Date(this.user.created_at).getFullYear();
      }
      return new Date().getFullYear();
    },
    avatarSrc() {
      if (this.avatarPreview) return this.avatarPreview;

      if (this.user?.avatar) {
        return `${this.user.avatar}?t=${Date.now()}`;
      }

      return require('@/assets/images/header/avatar.jpg');
    },
  },
  created() {
    this.$store.dispatch('auth/loadUser').then(() => {
      if (this.user?.birth_date) {
        this.tempValues.birth_date = new Date(this.user.birth_date);
      }

      if (this.user?.login) {
        this.tempValues.login = this.user.login;
      }

      if (this.user?.name) {
        this.tempValues.fullname = this.user.name;
      }

      if (this.user?.phone) {
        this.tempValues.phone = this.user.phone;
      }

      if (this.user?.email) {
        this.tempValues.email = this.user.email;
      }

      if (this.user?.country) {
        this.tempValues.country = this.user.country;
      }
      
      this.checkAmbassadorStatus();
      this.selectedLanguage = this.user?.language || this.$locale?.value || 'ru';
    });
  },
  methods: {
    async changeLanguage() {
      if (this.isLanguageSaving) return;
      const previousLanguage = this.user?.language || 'ru';
      this.isLanguageSaving = true;
      setLocale(this.selectedLanguage);
      try {
        const formData = new FormData();
        formData.append('language', this.selectedLanguage);
        const response = await this.$store.dispatch('auth/updateProfile', { profileData: formData });

        if (!response.success) {
          this.selectedLanguage = previousLanguage;
          setLocale(previousLanguage);
          this.toast.error(this.$t('account.languageSaveError'));
          return;
        }

        this.toast.success(this.$t('account.languageSaved'));
        try {
          await this.$store.dispatch('category/fetchCategories', { forceRefresh: true });
        } catch (error) {
          console.error('Failed to refresh localized categories:', error);
        }
      } catch (error) {
        this.selectedLanguage = previousLanguage;
        setLocale(previousLanguage);
        this.toast.error(this.$t('account.languageSaveError'));
      } finally {
        this.isLanguageSaving = false;
      }
    },
    async checkAmbassadorStatus() {
      if (!this.user?.id) return;
      try {
        const { getAmbassadorByUserId } = await import('@/api/ambassadors');
        const result = await getAmbassadorByUserId(this.user.id);
        this.isAmbassador = result.is_ambassador === true;
      } catch (err) {
        this.isAmbassador = false;
      }
    },
    async handleLogout() {
      await this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
    onPhoneInput(event) {
      const value = event.target?.value || this.tempValues.phone;
      const hasInvalidChars = /[a-zA-Zа-яА-Я]/.test(value);

      if (hasInvalidChars) {
        const cleanedValue = value.replace(/[a-zA-Zа-яА-Я]/g, '');
        this.tempValues.phone = cleanedValue;
      }
    },
    async handleSubmit() {
      try {
        const formData = new FormData();
        let hasValidData = false;

        Object.keys(this.tempValues).forEach((key) => {
          if (key === 'birth_date' && this.tempValues[key]) {
            const birthDateFormatted = this.tempValues.birth_date.toISOString().split('T')[0];
            formData.append(key, birthDateFormatted);
            hasValidData = true;
          } else if (this.tempValues[key] && this.tempValues[key].toString().trim() !== '') {
            formData.append(key, this.tempValues[key].toString().trim());
            hasValidData = true;
          }
        });

        if (!hasValidData) {
          this.toast.info(this.$t('Нет данных для обновления'));
          return;
        }

        if (formData.has('email') && !this.isValidEmail(this.tempValues.email)) {
          this.toast.error(this.$t('Введите корректный email адрес'));
          return;
        }

        const response = await this.$store.dispatch('auth/updateProfile', { profileData: formData });

        if (!response.success) {
          this.toast.error(this.$t('Ошибка при обновлении данных'));
        } else {
          this.toast.success(this.$t('Данные успешно обновлены'));

          Object.keys(this.editing).forEach((field) => {
            this.editing[field] = false;
          });
        }
      } catch (error) {
        console.error('Ошибка обновления профиля:', error);
        this.toast.error(this.$t('Произошла ошибка при обновлении данных'));
      }
    },
    isValidEmail(email) {
      if (!email || email.trim() === '') return true;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    resetForm() {
      this.tempValues = {
        login: this.user?.login || '',
        fullname: this.user?.name || '',
        phone: this.user?.phone || '',
        email: this.user?.email || '',
        birth_date: this.user?.birth_date ? new Date(this.user.birth_date) : null,
        country: this.user?.country || '',
      };

      Object.keys(this.editing).forEach((field) => {
        this.editing[field] = false;
      });
    },
    dateFormat(date) {
      return this.$formatDate(date, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
    },
    startEditing(field) {
      this.editing[field] = true;
      this.tempValues[field] = this.user[field] || '';
    },
    cancelEditing(field) {
      this.editing[field] = false;
    },
    toggleCountryDropdown() {
      this.showCountryDropdown = !this.showCountryDropdown;
    },
    selectCountry(country, event) {
      event.stopPropagation();
      this.tempValues.country = country;
      this.showCountryDropdown = false;
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.showCountryDropdown = false;
        this.activeMenuId = null;
      }
    },
    async saveField(field) {
      const birthDateFormated = this.tempValues.birth_date ? this.tempValues.birth_date.toISOString().split('T')[0] : null;
      const formData = new FormData();

      if (field === 'birth_date') {
        formData.append(field, birthDateFormated);
      } else {
        formData.append([field], this.tempValues[field]);
      }

      try {
        const response = await this.$store.dispatch('auth/updateProfile', { profileData: formData });
        this.editing[field] = false;

        if (!response.success) {
          this.toast.error(this.$t('Не корректное поле'));
        } else {
          this.toast.success(this.$t('Данные успешно обновлены'));
        }
      } catch (error) {
        console.error('Ошибка обновления профиля:', error);
      }
    },
    triggerAvatarUpload() {
      this.$refs.avatarInput.click();
    },
    onAvatarChange(e) {
      const file = e.target.files[0];
      if (!file || !file.type.match('image.*')) {
        e.target.value = '';
        return;
      }
      this.$store.dispatch('ui/clearAvatarPreview');
      this.$store.dispatch('ui/updateAvatarPreview', file);
      this.avatarFile = file;
      e.target.value = '';
      this.uploadAvatar();
    },

    async uploadAvatar() {
      if (!this.avatarFile) return;
      this.$store.dispatch('ui/setUploadingStatus', true);
      this.uploadProgress = 0;
      try {
        const formData = new FormData();
        formData.append('avatar', this.avatarFile);

        const onUploadProgress = (progressEvent) => {
          if (progressEvent.total) {
            this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          }
        };

        const response = await this.$store.dispatch('auth/updateProfile', { 
          profileData: formData, 
          onUploadProgress 
        });

        if (response.success && response.result.user?.avatar) {
          this.$store.commit('auth/SET_USER', response.result.user);
          this.$store.dispatch('ui/clearAvatarPreview');
          this.$store.dispatch('ui/updateAvatarSrc', response.result.user.avatar);
          this.toast.success(this.$t('Аватар успешно обновлен'));
        } else {
          console.warn('Аватар не обновлен, сервер не вернул URL');
          this.toast.error(this.$t('Аватар не обновлен'));
        }
      } catch (e) {
        console.error('Ошибка загрузки аватара:', e);
        this.toast.error(this.$t('Ошибка загрузки аватара'));
      } finally {
        this.$store.dispatch('ui/setUploadingStatus', false);
        this.uploadProgress = 0;
      }
    },
  },
  beforeUnmount() {
    if (this.avatarPreview) {
      URL.revokeObjectURL(this.avatarPreview);
    }

    document.removeEventListener('click', this.handleClickOutside);
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
};
</script>

<style>
.dp__input {
  --dp-border-radius: 10px;
  --dp-border-color: #fafafa;
  min-height: 50px;
  box-shadow: inset 1px 1px 4px 0 rgba(18, 34, 55, 0.2);
  padding: 10px 50px 10px 20px;
}

.dp__input_icon {
  right: 20px;
  left: auto;
}

.dp--clear-btn {
  right: 50px;
}
</style>

<style scoped>
.content-block__row {
  max-width: 1070px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0 30px;
}

.content-block__column {
  max-width: 470px;
}

.spacer-10 {
  height: 10px;
  display: block;
}

.language-settings {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  max-width: 1070px;
}

.language-settings h2 {
  margin: 0 0 6px;
  color: #26374e;
  font-size: 18px;
}

.language-settings p,
.language-select-label span {
  margin: 0;
  color: #6b7280;
  font-size: 14px;
}

.language-select-label {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 220px;
}

.language-select {
  min-height: 46px;
  padding: 0 14px;
  border: 1px solid #d8dee6;
  border-radius: 10px;
  background: #fff;
  color: #26374e;
  font: inherit;
}

@media (max-width: 768px) {
  .language-settings {
    align-items: stretch;
    flex-direction: column;
  }

  .language-select-label {
    min-width: 0;
  }
}

.side-slide {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  font-weight: 400;
  font-size: 15px;
  line-height: 120%;
  color: #555;
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 8px;
  border: 1px solid transparent;
  text-decoration: none;
}

.side-slide svg {
  flex-shrink: 0;
  color: #888;
  transition: color 0.2s;
}

.side-slide:hover {
  background: #f5f7fa;
  color: #333;
}

.side-slide:hover svg {
  color: #555;
}

.side-slide p {
  margin: 0;
  color: inherit;
}

.side-slide a {
  color: inherit;
}

.side-slide.active {
  background: #f0f4f8;
  border-color: #e0e6ed;
  color: #496782;
  font-weight: 500;
}

.side-slide.active svg {
  color: #496782;
}

.side-slide + .side-slide {
  margin-top: 5px;
}

.content-block {
  border: 1px solid #fafafa;
  width: 528px;
  background-color: white;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 3px 3px 4px 0 rgba(178, 176, 173, 0.2);
}

.content-block--full {
  width: 100%;
}

/* Стили для селекта */
.select-wrapper {
  position: relative;
  margin-top: 8px;
}

.country-select {
  width: 100%;
  padding: 12px 40px 12px 16px;
  height: 48px;
  border: 1px solid #e5e5ea;
  border-radius: 8px;
  font-size: 16px;
  color: #1a1a1a;
  background-color: white;
  appearance: none;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.08), inset 0 1px 2px rgba(0, 0, 0, 0.1);
}

.country-select:focus {
  border-color: #0066ff;
  outline: none;
  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.08), inset 0 1px 2px rgba(0, 0, 0, 0.1), 0 0 0 2px rgba(0, 102, 255, 0.1);
}

.country-select option {
  padding: 8px 16px;
  color: #1a1a1a;
  background-color: white;
}

.country-select option:disabled {
  color: #bbcad8;
  background-color: white;
}

.country-select option:checked:not(:disabled) {
  background-color: #f5f7fa;
}

.select-wrapper::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6L8 10L12 6' stroke='%238E8E93' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  pointer-events: none;
}

/* Остальные стили */
.profile-header {
  display: flex;
  align-items: center;
  gap: 20px;
}

.avatar-container {
  position: relative;
}

.avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  background: #c2cfdc;
}

.camera-icon-wrapper {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  backdrop-filter: blur(4px);
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.1);
  background: #f6f2ef;
  color: #999;
}

.avatar-progress-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-circle {
  position: relative;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circular-progress {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.circle-bg {
  fill: none;
  stroke: rgba(255, 255, 255, 0.3);
  stroke-width: 3;
}

.circle-progress {
  fill: none;
  stroke: #fff;
  stroke-width: 3;
  stroke-linecap: round;
  transition: stroke-dasharray 0.3s ease;
}

.progress-text {
  position: absolute;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
}

.file-input {
  display: none;
}

.spinner {
  width: 24px;
  height: 24px;
  animation: rotate 2s linear infinite;
}

.spinner .path {
  stroke: #0066ff;
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}

.profile-info h1 {
  margin-bottom: 10px;
  font-weight: 400;
  font-size: 24px;
  line-height: 120%;
  color: #1a1a1a;
}

.registration {
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  color: #999;
}

.edit-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: auto;
}

.divider {
  height: 1px;
  background-color: #e5e5ea;
  margin: 16px 0;
}

.detail-item {
  margin-bottom: 20px;
}

.detail-item-row {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.detail-item--half {
  flex: 1;
  margin-bottom: 0;
}

.content-block__action {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 30px;
  margin-top: 10px;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.detail-title {
  display: block;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  color: #999;
  margin-bottom: 10px;
}

.detail-value {
  font-size: 16px;
  color: #1a1a1a;
}

.edit-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e5e5ea;
  border-radius: 8px;
  font-size: 16px;
}

.edit-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.save-btn {
  padding: 6px 12px;
  background-color: #0055cc;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.cancel-btn {
  padding: 6px 12px;
  background-color: transparent;
  border: 1px solid #e5e5ea;
  border-radius: 4px;
  cursor: pointer;
}

.additional-block {
  margin-top: 24px;
}

.birthday-fields {
  display: flex;
  gap: 12px;
}

.birthday-input {
  flex: 1;
  padding: 12px 16px;
  border: 1px solid #e5e5ea;
  border-radius: 8px;
  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.08), inset 0 1px 2px rgba(0, 0, 0, 0.1);
}

.birthday-input::placeholder {
  color: #bbcad8;
}

/* Адаптивные стили */
@media (max-width: 768px) {
  .content-block__row {
    grid-template-columns: 100%;
    gap: 0;
  }

  .content-block {
    padding: 20px 10px;
  }

  .content-block__column {
    max-width: 100%;
  }

  .content-block {
    width: 100%;
    border: none;
    box-shadow: none;
    margin: 0;
    padding: 20px 16px;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  }

  .profile-header {
    flex-direction: column;
    text-align: center;
  }

  .edit-icon {
    margin: 8px auto 0;
  }

  .birthday-fields {
    flex-direction: column;
  }

  .detail-item-row {
    flex-direction: column;
    gap: 0;
  }

  .detail-item--half {
    margin-bottom: 20px;
  }

  .country-select {
    height: 44px;
  }
}

.custom-select {
  position: relative;
  width: 100%;
  margin-top: 8px;
  cursor: pointer;
}

.select-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border: 1px solid #e5e5ea;
  border-radius: 8px;
  background-color: white;
  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.08), inset 0 1px 2px rgba(0, 0, 0, 0.1);
  height: 48px;
}

.selected-option {
  font-size: 16px;
  color: #1a1a1a;
}

.selected-option.placeholder {
  color: #bbcad8;
}

.dropdown-icon {
  width: 16px;
  height: 16px;
  transition: transform 0.2s ease;
}

.dropdown-icon.rotated {
  transform: rotate(180deg);
}

.dropdown-options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 200px;
  overflow-y: auto;
  background-color: white;
  border: 1px solid #e5e5ea;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10;
  margin-top: 4px;
}

.option {
  padding: 12px 16px;
  font-size: 16px;
  color: #1a1a1a;
  transition: background-color 0.2s;
}

.option:hover {
  background-color: #f5f7fa;
}

/* Анимация для выпадающего списка */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Адаптивные стили */
@media (max-width: 768px) {
  .select-header {
    height: 44px;
    padding: 10px 14px;
  }

  .dropdown-options {
    max-height: 180px;
  }

  .option {
    padding: 10px 14px;
  }
}
</style>
